module.exports = __webpack_public_path__ + "sm.svg?910e003cd97c5b4465447e0c3a9c812c";